/**
 * Alert Fiedset Module is a reusable Module
 */

// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// imports
import { FocusMeModule } from "../../../../directive/focusMe/focusMe.module";
import { DateParserModule } from '../../../../service/date/dateParser.module';
import { DateFieldModule } from "../date-field/date-field.module";
import { DateModule } from "libraries/module/formbuilder/fields/date/date.module";
import { CalendarModule } from "primeng/calendar";
import { Date2monthsFieldComponent } from "./date2months-field.component";

/**
 * @deprecated
 */
@NgModule({
    imports: [
        CalendarModule,
        CommonModule,
        DateFieldModule,
        DateParserModule,
        FocusMeModule,
        FormsModule,
        ReactiveFormsModule,
        DateFieldModule,
        DateModule,
    ],
    declarations: [
        Date2monthsFieldComponent,
    ],
    exports: [
        Date2monthsFieldComponent,
    ]
})
export class Date2MonthsModule {}
